import { createGlobalStyle } from 'styled-components'
import {
  TABLE_BORDER_COLOR,
  TABLE_FONT_FAMILY,
  TABLE_HEADER_FONT_FAMILY,
  TABLE_HEADER_FONT_SIZE,
  TABLE_HEADER_FONT_WEIGHT
} from './tableTokens'

// Nested tree table rows get darker per level, starting from #f9f9f9 and dropping 2% lightness each level
const tableRowLevelStyles = Array.from({ length: 10 }, (_, index) => {
  const level = index + 1
  const channel = Math.round((249 - index * 5.1) * 10) / 10
  const color = `rgb(${channel}, ${channel}, ${channel})`
  return `
  .ant-table-row-level-${level},
  .ant-table-row-level-${level} .ant-table-cell-fix-left {
    background-color: ${color};
  }`
}).join('')

const GlobalStyle = createGlobalStyle`
  body {
    font-family: 'Manrope', sans-serif;
  }

  ${tableRowLevelStyles}

  .ant-statistic-content-value,
  .ant-statistic-content-value-int,
  .ant-statistic-content-prefix {
    font-size: 20px;
  }

  .hidden-column {
    visibility: hidden;
    white-space: nowrap;
  }

  .hover-link {
    cursor: pointer;

    &:hover {
      color: var(--ant-color-link, #1890ff);
    }
  }

  .ant-menu-item a {
    text-overflow: ellipsis;
    overflow-x: hidden;
    overflow-y: hidden;
  }

  /* Same fonts as ag-grid (config/agGrid/theme) */
  table {
    font-family: ${TABLE_FONT_FAMILY};

    th {
      font-family: ${TABLE_HEADER_FONT_FAMILY};
    }
  }

  .ant-table-wrapper .ant-table-thead > tr > th {
    font-size: ${TABLE_HEADER_FONT_SIZE}px;
    font-weight: ${TABLE_HEADER_FONT_WEIGHT};
  }

  /*
   * Every antd table gets an outer frame like the ag-grid wrapper border (antd has no global "bordered"
   * default). The bottom edge comes from the last row's own border.
   */
  .ant-table-wrapper .ant-table:not(.ant-table-bordered) > .ant-table-container {
    border: 1px solid ${TABLE_BORDER_COLOR};
    border-bottom: none;
  }

  /* Pagination below a table continues the table frame */
  .ant-table-wrapper .ant-table + .ant-table-pagination.ant-pagination {
    margin: 0;
    padding: 8px;
    border: 1px solid ${TABLE_BORDER_COLOR};
    border-top: none;
    border-end-start-radius: 8px;
    border-end-end-radius: 8px;
  }

  .ant-table-small {
    border: none;
  }

  @media only screen and (max-width: 425px) {
    .ant-card-body {
      padding: 12px !important;
    }
  }
`

export default GlobalStyle
